import { jsx as _jsx } from "react/jsx-runtime";
import { Chip, Typography, useTheme } from "@mui/material";
export const SubsStatusChip = ({ currentSubscriptionStatus }) => {
    const theme = useTheme();
    const CHIP_BACKGROUNDS = {
        Active: theme.palette.success.light,
        Paused: theme.palette.info.light,
        Cancelled: theme.palette.error.light,
        Complete: theme.palette.common.black,
        None: theme.palette.common.black,
    };
    const backgroundColor = CHIP_BACKGROUNDS[currentSubscriptionStatus];
    return (_jsx(Chip, { size: "medium", 
        // Tenant themes can give body1 its own color, which would override the chip's.
        label: _jsx(Typography, Object.assign({ variant: "body1", color: "inherit" }, { children: currentSubscriptionStatus })), variant: "filledSquared", sx: {
            backgroundColor,
            // A palette's contrastText is picked for its main shade; tenant semantic colors can make that unreadable on light.
            color: backgroundColor ? theme.palette.getContrastText(backgroundColor) : undefined,
        } }));
};
